module.exports = __webpack_public_path__ + "media/images/photos/10-82fa140202ec0a459d4cf93eeb962a2e.jpg";